// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as IncentiveCampaignApiModel from "../api-model/IncentiveCampaignApiModel.bs.js";

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(IncentiveCampaignApiModel.res_decode(json), "IncentiveEntityMapper.res").result;
  var config = function (data) {
    return List.map((function (e) {
                  return {
                          target: e.target,
                          incentive_amount: e.incentive_amount
                        };
                }), data);
  };
  var validator = function (data) {
    return List.map((function (e) {
                  var match = e.validator_name;
                  var tmp;
                  switch (match) {
                    case "ABRTG" :
                        tmp = /* ABRTG */1;
                        break;
                    case "FRAUD_ORDER" :
                        tmp = /* FRAUD_ORDER */2;
                        break;
                    case "MISSED_ORDER" :
                        tmp = /* MISSED_ORDER */0;
                        break;
                    default:
                      throw {
                            RE_EXN_ID: "Match_failure",
                            _1: [
                              "IncentiveEntityMapper.res",
                              10,
                              30
                            ],
                            Error: new Error()
                          };
                  }
                  return {
                          validator_name: tmp,
                          threshold: e.threshold,
                          value: e.value,
                          status: e.status
                        };
                }), data);
  };
  return List.map((function (e) {
                var match = e.campaign_status;
                var tmp;
                switch (match) {
                  case "COMPLETED" :
                      tmp = /* COMPLETED */0;
                      break;
                  case "DISQUALIFIED" :
                      tmp = /* DISQUALIFIED */1;
                      break;
                  case "IN_PROGRESS" :
                      tmp = /* IN_PROGRESS */2;
                      break;
                  default:
                    throw {
                          RE_EXN_ID: "Match_failure",
                          _1: [
                            "IncentiveEntityMapper.res",
                            24,
                            25
                          ],
                          Error: new Error()
                        };
                }
                return {
                        start_date: Timestamp$Catalyst.make(e.start_date * 1000.0),
                        end_date: Timestamp$Catalyst.make(e.end_date * 1000.0),
                        campaign_status: tmp,
                        ladder_based: e.ladder_based,
                        payout: {
                          param_name: e.payout.param_name,
                          config: config(e.payout.config),
                          param_current_value: e.payout.param_current_value
                        },
                        validators: validator(e.validators)
                      };
              }), model.campaigns);
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
